<template>
  <div class="flex-box">
    <div class="search-box">
      <div v-if="$hasPermission('A30201')">
        <label class="searchItemName">渠道：</label>
        <el-select v-model="queryParams.channelId" clearable placeholder="筛选渠道">
          <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
        </el-select>
      </div>
      <div v-if="$hasPermission('A30205')">
        <label class="searchItemName">设备号：</label>
        <el-input class="input-box" placeholder="设备编号" v-model="queryParams.deviceCode" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <el-button v-if="$hasPermission('A30205')" style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
      <el-button v-if="$hasPermission('A30202')" type="success" icon="el-icon-plus" @click="openDialog()">新增设备</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="deviceCode" label="设备编号" width="140" align="center"></el-table-column>
      <el-table-column prop="channelName" label="渠道" width="150" align="center"></el-table-column>
      <el-table-column prop="address" label="投放地址" min-width="160" align="center"></el-table-column>
      <el-table-column prop="payConfigName" label="支付配置" width="140" align="center"></el-table-column>
      <el-table-column label="支付终端" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.payIsActive ? 'success' : 'info'">{{ scope.row.payIsActive ? '已激活' : '未激活' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="paperCount" label="相纸" width="80" align="center"></el-table-column>
      <el-table-column prop="softVersion" label="版本" width="90" align="center"></el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="170" align="center"></el-table-column>
      <el-table-column label="操作" min-width="320" width="360" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button class="operating-button" v-if="$hasPermission('A30203')" type="primary" size="mini" plain @click="openDialog(scope.row)">编辑</el-button>
          <el-button class="operating-button" v-if="$hasPermission('A30211')" type="primary" size="mini" plain @click="openPhotoTypeDialog(scope.row)">相片设置</el-button>
          <el-button class="operating-button" v-if="$hasPermission('A30208')" type="info" size="mini" plain @click="openConfigDialog(scope.row)">配置信息</el-button>
          <el-button class="operating-button" v-if="$hasPermission('A30210') && !scope.row.payIsActive" type="success" size="mini" plain @click="activatePay(scope.row)">激活支付</el-button>
          <el-button class="operating-button" v-if="$hasPermission('A30206') && scope.row.status !== 1" type="success" size="mini" plain @click="setStatus(scope.row, 304, '启用')">启用</el-button>
          <el-button class="operating-button" v-if="$hasPermission('A30207') && scope.row.status === 1" type="warning" size="mini" plain @click="setStatus(scope.row, 305, '禁用')">禁用</el-button>
          <el-button class="operating-button" v-if="$hasPermission('A30204')" type="danger" size="mini" plain @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="form.id ? '编辑设备' : '新增设备'" :visible.sync="dialogVisible" width="520px">
      <el-form :model="form" label-width="110px">
        <el-form-item label="设备编号">
          <el-input v-model="form.deviceCode" :disabled="!!form.id" placeholder="设备编号"></el-input>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select v-model="form.channelId" placeholder="请选择渠道" style="width: 100%;">
            <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付配置">
          <el-select v-model="form.payConfigId" placeholder="请选择支付配置" style="width: 100%;">
            <el-option v-for="item in payConfigs" :key="item.id" :label="item.payConfigName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放地址"><el-input v-model="form.address" placeholder="投放地址"></el-input></el-form-item>
        <el-form-item label="设备密钥">
          <el-input v-model="form.deviceKey" placeholder="点击右侧按钮生成密钥">
            <el-button slot="append" @click="generateDeviceKey">生成</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'相片规格 - ' + photoTypeDevice.deviceCode" :visible.sync="photoTypeDialogVisible" width="640px">
      <div v-if="photoTypeLoading" style="color: #909399; line-height: 22px;">正在加载规格...</div>
      <div v-else-if="allPhotoTypes.length === 0" style="color: #909399; line-height: 22px;">
        暂无可用相片规格，请先在「相片规格」中添加。
      </div>
      <template v-else>
        <div style="margin-bottom: 10px;">
          <el-button type="text" @click="selectAllPhotoTypes">全选</el-button>
          <el-button type="text" @click="selectedPhotoTypeIds = []">清空</el-button>
          <span style="margin-left: 8px; color: #909399;">已选 {{ selectedPhotoTypeIds.length }} / {{ allPhotoTypes.length }}</span>
        </div>
        <el-checkbox-group v-model="selectedPhotoTypeIds">
          <div v-for="item in allPhotoTypes" :key="item.id" class="photo-type-item">
            <el-checkbox :label="item.id">
              <span>{{ item.name }}</span>
              <span class="photo-type-meta">
                {{ item.specWidth }} × {{ item.specHeght }}
                <template v-if="item.specSize"> · {{ item.specSize }}</template>
                · {{ formatMoney(item.fee) }} 元
              </span>
            </el-checkbox>
          </div>
        </el-checkbox-group>
      </template>
      <div slot="footer">
        <el-button @click="photoTypeDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="photoTypeLoading || allPhotoTypes.length === 0" @click="savePhotoTypes()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="configDialogTitle" :visible.sync="configDialogVisible" width="92%">
      <div class="device-config-split">
        <div class="device-config-form-panel">
          <el-form :model="deviceConfig" label-width="220px" size="small">
            <el-collapse v-model="activeConfigSections">
              <el-collapse-item v-for="group in configSchema" :key="group.name" :title="group.title" :name="group.name">
                <el-form-item v-for="field in group.fields" :key="field.key" :label="field.label">
                  <el-input v-if="field.type === 'string'" class="config-form-input" v-model="deviceConfig[field.key]"
                    :placeholder="field.placeholder || ''" clearable></el-input>
                  <el-input v-else-if="field.type === 'password'" class="config-form-input" v-model="deviceConfig[field.key]"
                    type="password" show-password :placeholder="field.placeholder || ''" clearable></el-input>
                  <el-input-number v-else-if="field.type === 'int'" class="config-form-number" v-model="deviceConfig[field.key]"
                    :min="field.min" :max="field.max" :step="field.step || 1" controls-position="right"></el-input-number>
                  <el-input-number v-else-if="field.type === 'double'" class="config-form-number" v-model="deviceConfig[field.key]"
                    :precision="field.precision || 2" :step="field.step || 0.1" :min="field.min" :max="field.max"
                    controls-position="right"></el-input-number>
                  <el-switch v-else-if="field.type === 'bool'" v-model="deviceConfig[field.key]"></el-switch>
                  <el-select v-else-if="field.type === 'select'" class="config-form-input" v-model="deviceConfig[field.key]"
                    :placeholder="field.placeholder || '请选择'" clearable>
                    <el-option v-for="opt in field.options" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </el-form>
          <el-form label-width="220px" size="small" style="margin-top: 12px;">
            <el-form-item label="设备配置密码">
              <el-input class="config-form-input" v-model="deviceConfigModel.password"
                type="password" show-password placeholder="设备配置密码" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="device-config-json-panel">
          <div class="device-config-json-title">JSON 配置（与左侧表单联动，保存到 ConfigData）</div>
          <vue-json-editor v-model="deviceConfigJson" class="jsoneditoramenu device-config-json-editor"
            :mode="'code'"
            :show-btns="false"
            @json-change="onDeviceConfigJsonChange"
            @has-error="onDeviceConfigJsonError"
            style="height: calc(65vh - 36px);"/>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="configDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveDeviceConfig()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor'
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

const DEVICE_CONFIG_SCHEMA = [
  {
    name: 'hardware',
    title: '硬件与端口',
    fields: [
      { key: 'PlcPort', label: 'PLC端口号', type: 'string', placeholder: 'COM3' },
      {
        key: 'PlcBaudRate',
        label: 'PLC波特率',
        type: 'select',
        placeholder: '请选择波特率',
        options: [
          { label: '9600', value: 9600 },
          { label: '19200', value: 19200 },
          { label: '38400', value: 38400 },
          { label: '57600', value: 57600 },
          { label: '115200', value: 115200 }
        ]
      },
      { key: 'PhotoPrinterName', label: 'DNP打印机名称', type: 'string', placeholder: 'DS-RX1' },
      { key: 'PhotoPrinterSerialNumber', label: 'DNP序列号', type: 'string' }
    ]
  },
  {
    name: 'storage',
    title: '目录与日志',
    fields: [
      { key: 'OriginalPath', label: '原图目录', type: 'string', placeholder: 'D:\\Photo\\Source\\' },
      { key: 'SnapPath', label: '照片目录', type: 'string', placeholder: 'D:\\Photo\\Picture\\' },
      { key: 'CutPath', label: '裁切图目录', type: 'string', placeholder: 'D:\\Photo\\Cut\\' },
      { key: 'PhotoPrintPath', label: '打印图目录', type: 'string', placeholder: 'D:\\Photo\\Print\\' },
      { key: 'LogSaveDays', label: '日志保存天数', type: 'int', min: 0 }
    ]
  },
  {
    name: 'camera',
    title: '相片服务与摄像头',
    fields: [
      { key: 'PhotoSvrURL', label: '相片服务URL', type: 'string', placeholder: 'http://' },
      { key: 'PhotoSvrKey', label: '相片处理服务Key', type: 'string', placeholder: 'appkey' },
      { key: 'PhotoSvrSecret', label: '相片处理服务密钥', type: 'password', placeholder: 'secret' },
      { key: 'PhotoCamera', label: '摄像头', type: 'string', placeholder: '友好名称或 vid_xxxx&pid_xxxx\\global' },
      { key: 'CameraFlip', label: '是否翻转画面', type: 'bool' }
    ]
  },
  {
    name: 'face',
    title: '人脸识别',
    fields: [
      {
        key: 'SimilarityRatio',
        label: '人证比对相似度阈值',
        type: 'int',
        min: 0,
        max: 100,
        placeholder: '80'
      }
    ]
  },
  {
    name: 'mqtt',
    title: 'MQTT 与客服',
    fields: [
      { key: 'MQTT_IP', label: 'MQTT IP', type: 'string' },
      { key: 'MQTT_Port', label: 'MQTT 端口', type: 'int', min: 0, placeholder: '1883' },
      { key: 'MQTT_Name', label: 'MQTT 用户名', type: 'string' },
      { key: 'MQTT_Password', label: 'MQTT 密码', type: 'password' },
      { key: 'Hotline', label: '服务热线', type: 'string', placeholder: '400-860-0000' }
    ]
  }
]

export default {
  mixins: [listPage],
  components: { vueJsonEditor },
  data() {
    return {
      total: 0,
      channels: [],
      payConfigs: [],
      queryParams: { pageIndex: 1, pageSize: 10, channelId: '', deviceCode: '' },
      tableData: [],
      dialogVisible: false,
      form: {},
      photoTypeDialogVisible: false,
      photoTypeDevice: { id: 0, deviceCode: '' },
      allPhotoTypes: [],
      selectedPhotoTypeIds: [],
      photoTypeLoading: false,
      configDialogVisible: false,
      configDialogTitle: '设备配置',
      configOperationType: 'add',
      deviceConfig: {},
      deviceConfigJson: {},
      deviceConfigJsonError: false,
      deviceConfigModel: {},
      activeConfigSections: DEVICE_CONFIG_SCHEMA.map(group => group.name),
      configSchema: DEVICE_CONFIG_SCHEMA
    }
  },
  created() {
    this.loadOptions()
    this.GetData()
  },
  methods: {
    statusText(status) {
      if (status === 1) return '正常'
      if (status === 0) return '未激活'
      if (status === -2) return '禁用'
      return '未知'
    },
    statusType(status) {
      if (status === 1) return 'success'
      if (status === 0) return 'info'
      return 'danger'
    },
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    loadOptions() {
      post(208, { channelName: '' }).then(response => {
        if (response.data.result == 0 && Array.isArray(response.data.data)) {
          this.channels = response.data.data
        }
      }).catch(() => {})

      post(215, { pageIndex: 1, pageSize: 200, payConfigName: '' }).then(response => {
        if (response.data.result == 0) {
          const data = response.data.data
          this.payConfigs = Array.isArray(data) ? data : ((data && data.list) || [])
        }
      }).catch(() => {})
    },
    GetData() {
      const loading = this.openLoading()
      post(306, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        channelId: this.queryParams.channelId || 0,
        deviceCode: (this.queryParams.deviceCode || '').trim()
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    },
    openDialog(row) {
      this.form = row
        ? {
          id: row.id,
          deviceCode: row.deviceCode,
          channelId: row.channelId,
          payConfigId: row.payConfigId,
          address: row.address || '',
          paperCount: row.paperCount || 0,
          deviceKey: row.deviceKey || ''
        }
        : { deviceCode: '', channelId: '', payConfigId: '', address: '', paperCount: 0, deviceKey: '' }
      this.dialogVisible = true
    },
    openPhotoTypeDialog(row) {
      this.photoTypeDevice = { id: row.id, deviceCode: row.deviceCode || '' }
      this.allPhotoTypes = []
      this.selectedPhotoTypeIds = []
      this.photoTypeLoading = true
      this.photoTypeDialogVisible = true
      const loading = this.openLoading()
      Promise.all([
        post(224, { name: '' }),
        post(308, { deviceId: row.id })
      ]).then(([typeRes, deviceRes]) => {
        loading.close()
        this.photoTypeLoading = false
        if (typeRes.data.result != 0) {
          this.$message.error('加载规格失败：' + typeRes.data.message)
          return
        }
        if (deviceRes.data.result != 0) {
          this.$message.error('加载设备规格失败：' + deviceRes.data.message)
          return
        }
        const types = Array.isArray(typeRes.data.data) ? typeRes.data.data : []
        this.allPhotoTypes = types
        const assigned = ((deviceRes.data.data && deviceRes.data.data.list) || [])
        this.selectedPhotoTypeIds = assigned
          .map(item => Number(item.photoTypeId))
          .filter(id => id > 0)
      }).catch(error => {
        loading.close()
        this.photoTypeLoading = false
        this.$message.error((error && error.userMessage) || '加载规格失败')
      })
    },
    selectAllPhotoTypes() {
      this.selectedPhotoTypeIds = this.allPhotoTypes.map(item => item.id)
    },
    savePhotoTypes() {
      if (!this.photoTypeDevice.id) {
        this.$message.error('设备信息异常')
        return
      }
      const loading = this.openLoading()
      post(309, {
        deviceId: this.photoTypeDevice.id,
        photoTypeIds: this.selectedPhotoTypeIds.map(id => Number(id)).filter(id => id > 0)
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.$message.success(response.data.message || '保存成功')
          this.photoTypeDialogVisible = false
        } else {
          this.$message.error('保存失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || '保存失败')
      })
    },
    generateDeviceKey() {
      const bytes = new Uint8Array(16)
      if (window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(bytes)
      } else {
        for (let i = 0; i < bytes.length; i++) {
          bytes[i] = Math.floor(Math.random() * 256)
        }
      }
      this.form.deviceKey = Array.from(bytes, b => ('0' + b.toString(16).toUpperCase()).slice(-2)).join('')
    },
    save() {
      const deviceCode = (this.form.deviceCode || '').trim()
      if (!deviceCode) {
        this.$message.error('设备编号不能为空')
        return
      }
      if (!this.form.channelId) {
        this.$message.error('请选择渠道')
        return
      }
      if (!this.form.payConfigId) {
        this.$message.error('请选择支付配置')
        return
      }

      const isEdit = !!this.form.id
      const payload = {
        deviceCode,
        channelId: this.form.channelId,
        payConfigId: this.form.payConfigId,
        address: (this.form.address || '').trim(),
        paperCount: this.form.id ? (Number(this.form.paperCount) || 0) : 0,
        deviceKey: (this.form.deviceKey || '').trim()
      }
      if (isEdit) payload.id = this.form.id

      const loading = this.openLoading()
      post(isEdit ? 302 : 301, payload).then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.$message.success(isEdit ? '修改成功' : '添加成功')
          this.dialogVisible = false
          this.GetData()
        } else {
          this.$message.error((isEdit ? '修改失败：' : '添加失败：') + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || (isEdit ? '修改失败' : '添加失败'))
      })
    },
    activatePay(row) {
      this.$confirm(`确认激活设备「${row.deviceCode}」的收钱吧支付终端吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '激活',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(307, { objId: row.id }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$message.success(response.data.message || '激活成功')
            this.GetData()
          } else {
            this.$message.error('激活失败：' + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || '激活失败')
        })
      }).catch(() => {})
    },
    setStatus(row, api, action) {
      this.$confirm(`确认${action}设备「${row.deviceCode}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: action,
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(api, { objId: row.id }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$message.success(response.data.message || `${action}成功`)
            this.GetData()
          } else {
            this.$message.error(`${action}失败：` + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || `${action}失败`)
        })
      }).catch(() => {})
    },
    remove(row) {
      this.$confirm(`确认删除设备「${row.deviceCode}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(303, { objId: row.id }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.queryParams.pageIndex > 1) {
              this.queryParams.pageIndex -= 1
            }
            this.GetData()
          } else {
            this.$message.error('删除失败：' + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || '删除失败')
        })
      }).catch(() => {})
    },
    getDefaultDeviceConfig() {
      return {
        PlcPort: '',
        PlcBaudRate: null,
        PhotoPrinterName: '',
        PhotoPrinterSerialNumber: '',
        OriginalPath: '',
        SnapPath: '',
        CutPath: '',
        PhotoPrintPath: '',
        LogSaveDays: null,
        PhotoSvrURL: '',
        PhotoSvrKey: '',
        PhotoSvrSecret: '',
        PhotoCamera: '',
        CameraFlip: false,
        SimilarityRatio: 80,
        MQTT_IP: '',
        MQTT_Port: null,
        MQTT_Name: '',
        MQTT_Password: '',
        Hotline: ''
      }
    },
    getConfigFieldTypes() {
      const types = {}
      DEVICE_CONFIG_SCHEMA.forEach(group => {
        group.fields.forEach(field => {
          types[field.key] = field.type
        })
      })
      return types
    },
    normalizeConfig(raw) {
      const config = this.getDefaultDeviceConfig()
      if (!raw || typeof raw !== 'object') return config
      const types = this.getConfigFieldTypes()
      // 兼容历史键名 photoProcessingURL → PhotoSvrURL
      const source = { ...raw }
      if ((source.PhotoSvrURL === undefined || source.PhotoSvrURL === null || source.PhotoSvrURL === '')
        && source.photoProcessingURL) {
        source.PhotoSvrURL = source.photoProcessingURL
      }
      Object.keys(config).forEach(key => {
        if (source[key] === undefined || source[key] === null || source[key] === '') return
        const type = types[key]
        if (type === 'bool') {
          config[key] = source[key] === true || source[key] === 'true' || source[key] === 1 || source[key] === '1'
        } else if (type === 'int' || (type === 'select' && typeof config[key] !== 'boolean')) {
          const num = Number(source[key])
          if (!isNaN(num)) config[key] = num
        } else {
          config[key] = String(source[key])
        }
      })
      return config
    },
    parseConfigBundle(configStr) {
      const defaults = this.getDefaultDeviceConfig()
      if (!configStr) {
        return { form: { ...defaults }, json: { ...defaults } }
      }
      try {
        const raw = JSON.parse(configStr)
        if (!raw || typeof raw !== 'object') {
          return { form: { ...defaults }, json: { ...defaults } }
        }
        return { form: this.normalizeConfig(raw), json: { ...raw } }
      } catch (e) {
        this.$message.warning('配置数据格式异常，已加载默认表单')
        return { form: { ...defaults }, json: { ...defaults } }
      }
    },
    applyDeviceConfigBundle(bundle) {
      this._deviceConfigSyncing = true
      this.deviceConfig = bundle.form
      this.deviceConfigJson = bundle.json
      this.deviceConfigJsonError = false
      this.$nextTick(() => {
        this._deviceConfigSyncing = false
      })
    },
    onDeviceConfigJsonChange(value) {
      if (this._deviceConfigSyncing) return
      this.syncJsonToForm(value)
    },
    onDeviceConfigJsonError() {
      this.deviceConfigJsonError = true
    },
    syncFormToJson() {
      this._deviceConfigSyncing = true
      const merged = {
        ...(this.deviceConfigJson || {}),
        ...this.deviceConfig
      }
      // 保存时去掉历史键名，统一为 PhotoSvrURL
      if (Object.prototype.hasOwnProperty.call(merged, 'photoProcessingURL')) {
        delete merged.photoProcessingURL
      }
      this.deviceConfigJson = merged
      this.deviceConfigJsonError = false
      this.$nextTick(() => {
        this._deviceConfigSyncing = false
      })
    },
    syncJsonToForm(value) {
      this._deviceConfigSyncing = true
      const raw = value && typeof value === 'object' ? value : {}
      this.deviceConfigJson = { ...raw }
      const normalized = this.normalizeConfig(raw)
      Object.keys(normalized).forEach(key => {
        this.$set(this.deviceConfig, key, normalized[key])
      })
      this.deviceConfigJsonError = false
      this.$nextTick(() => {
        this._deviceConfigSyncing = false
      })
    },
    openConfigDialog(row) {
      this.activeConfigSections = DEVICE_CONFIG_SCHEMA.map(group => group.name)
      this.deviceConfigJsonError = false
      this._deviceConfigSyncing = true
      const defaults = this.getDefaultDeviceConfig()
      this.deviceConfig = { ...defaults }
      this.deviceConfigJson = { ...defaults }
      this.$nextTick(() => {
        this._deviceConfigSyncing = false
      })
      this.deviceConfigModel = {
        deviceId: row.id,
        configData: '',
        password: ''
      }
      const loading = this.openLoading()
      post(310, { objId: row.id }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.deviceConfigModel.configData = response.data.data.config
          this.deviceConfigModel.password = response.data.data.password
          this.configDialogTitle = '修改设备配置 - ' + (row.deviceCode || '')
          this.applyDeviceConfigBundle(this.parseConfigBundle(response.data.data.config))
          this.configOperationType = 'edit'
        } else {
          this.configDialogTitle = '添加设备配置 - ' + (row.deviceCode || '')
          this.applyDeviceConfigBundle({
            form: { ...defaults },
            json: { ...defaults }
          })
          this.configOperationType = 'add'
        }
        this.configDialogVisible = true
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || '获取设备配置失败')
      })
    },
    saveDeviceConfig() {
      if (this.deviceConfigJsonError) {
        this.$message.error('JSON 配置格式有误，请修正后再保存')
        return
      }
      this.syncFormToJson()
      this.deviceConfigModel.configData = JSON.stringify(this.deviceConfigJson)
      const isAdd = this.configOperationType === 'add'
      const loading = this.openLoading()
      post(isAdd ? 311 : 312, this.deviceConfigModel).then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.$message.success(isAdd ? '添加成功' : '修改成功')
          this.configDialogVisible = false
        } else {
          this.$message.error('操作失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || '操作失败')
      })
    }
  },
  watch: {
    deviceConfig: {
      deep: true,
      handler() {
        if (!this.configDialogVisible || this._deviceConfigSyncing) return
        this.syncFormToJson()
      }
    }
  }
}
</script>

<style scoped>
.photo-type-item {
  padding: 8px 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-bottom: 8px;
}
.photo-type-item:last-child {
  margin-bottom: 0;
}
.photo-type-meta {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}
.operating-button {
  margin: 2.5px 4px;
}
.device-config-split {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;
  min-height: 65vh;
}
.device-config-form-panel {
  flex: 1 1 52%;
  min-width: 0;
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;
  border-right: 1px solid #e4e7ed;
}
.device-config-json-panel {
  flex: 1 1 48%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.device-config-json-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}
.device-config-json-editor {
  flex: 1;
  min-height: 0;
}
.config-form-input,
.config-form-number {
  width: 100%;
}
@media (max-width: 1200px) {
  .device-config-split {
    flex-direction: column;
  }
  .device-config-form-panel {
    max-height: 40vh;
    border-right: none;
    border-bottom: 1px solid #e4e7ed;
    padding-bottom: 12px;
  }
  .device-config-json-panel {
    min-height: 320px;
  }
}
</style>
<style>
.jsoneditor-vue {
  height: 100%;
}
div.jsoneditor-menu a.jsoneditor-poweredBy {
  display: none;
}
</style>
